// extracted by mini-css-extract-plugin
module.exports = {"title":"changeEmail_title__3Xo-r","description":"changeEmail_description__rI_n6","phone_valid":"changeEmail_phone_valid__3LEbi"};